/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/5/21
 * Copyright All Rights Reserved
 */
import { analysisTypesById } from 'constants/analysisTypes';

const getInitialValues = (values) => {
  const { inventoryId } = values;
  const { analysisType } = values;
  const { searchParams, defaultSearchParamValues } = analysisTypesById[analysisType];

  const defaultedParameters = searchParams.reduce((acc, param) => {
    const value = values[param] || defaultSearchParamValues[param];
    return value === undefined
      ? acc
      : { ...acc, [param]: value };
  }, {});
  return {
    ...(inventoryId && inventoryId !== 'null' ? { inventoryId } : {}),
    ...{ analysisType },
    ...defaultedParameters,
  };
};

export default getInitialValues;



// WEBPACK FOOTER //
// ./js/support/inventoryPageControlForm/getInitialValues.js